import { sendShopifyAnalytics, getClientBrowserParameters } from './analytics'

import type { AnalyticsProvider } from '../'
import { isOnServer } from '@/utils/ssr'
import { EVENT_TRACKING_PRODUCT_ADDED, SHOP_ID } from '@/utils'
import { AnalyticsEventName } from './analytics-constants'
import type { ShopifyAnalyticsBase } from './analytics-types'
import { useShopifyCookies } from './useShopifyCookies'
import { getDomainName } from '@/utils/http'

interface ShopifyAnalytics extends AnalyticsProvider {
  analyticsData: ShopifyAnalyticsBase | null
}

const ShopifyAnalytics: ShopifyAnalytics = {
  isActive: false,
  analyticsData: null,
  init() {
    if (isOnServer) return
    this.isActive = true
    this.analyticsData = {
      hasUserConsent: true,
      shopId: `gid://shopify/Shop/${SHOP_ID}`,
      currency: 'USD',
      acceptedLanguage: 'EN',
    }
    // set the cookie domain to ".example.com" to make it accesible through all sub-doamin
    const domain = '.' + getDomainName()

    const options = {
      hasUserConsent: true,
      domain,
    }
    useShopifyCookies(options)
  },

  track(eventName: string, payload: any) {
    if (!this.isActive || !this.analyticsData || !eventName || !payload) return
    if (eventName === EVENT_TRACKING_PRODUCT_ADDED) {
      const { cart_id, products } = payload
      const cartData = {
        cartId: `gid://shopify/Checkout/${cart_id}`,
        products: products,
      }
      const addToCartPayload = {
        ...getClientBrowserParameters(),
        ...this.analyticsData,
        ...cartData,
      }

      sendShopifyAnalytics({
        eventName: AnalyticsEventName.ADD_TO_CART,
        payload: addToCartPayload,
      })
    }
    return
  },
  page() {
    if (!this.isActive || !this.analyticsData) return
    const payload = {
      ...getClientBrowserParameters(),
      ...this.analyticsData,
    }
    return sendShopifyAnalytics({
      eventName: AnalyticsEventName.PAGE_VIEW,
      payload,
    })
  },
  alias() {},
  reset() {},
  error() {
    return
  },
}

export default ShopifyAnalytics
